






































import { computed, defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useNamespacedStore } from '~/compositions/store'
import { Option } from '~/models/shared/types'
import { useI18n } from '~/compositions/i18n'

type StateColorName = 'greenonly' | 'redonly' | 'yellowonly'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: { CCustomSelect },
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()
    const { state: classifiedSearchState } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )
    const { t } = useI18n()

    const selectedValue = ref(props.selected.color)
    const stateColors: StateColorName[] = ['greenonly', 'redonly', 'yellowonly']

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const options = computed(() => [
      {
        label: t('all'),
        value: null
      },
      ...(props.searchables || []).map(s => ({
        value: s.v,
        label: s.n,
        count: s.c
      }))
    ])

    const selectedOption = computed(() =>
      options.value.find(option => option.value === selectedValue.value)
    )

    watch(
      () => props.selected,
      (newSelected: { color: StateColorName | null }) => {
        selectedValue.value = newSelected.color
      }
    )

    function onClear() {
      selectedValue.value = null

      changeParams(
        stateColors.map(s => ({
          name: s,
          value: null
        }))
      )
    }

    function onValueChange(value: StateColorName | null) {
      changeParams(
        stateColors.map(s => ({
          name: s,
          value: s === value ? 1 : null
        }))
      )
    }

    function getColorClass(option: Option) {
      const colors: Record<StateColorName, string> = {
        greenonly: 'tw-bg-green',
        redonly: 'tw-bg-red',
        yellowonly: 'tw-bg-yellow'
      }

      return colors[option.value as StateColorName]
    }

    return {
      selectedOption,
      selectedValue,
      loadingFacets,
      options,
      onClear,
      getColorClass,
      onValueChange
    }
  }
})
